export const AUDIO_PATHS = {
  countdownTick: '/assets/audio/countdown_tick.wav',
  restStart: '/assets/audio/rest_start.wav',
  roundComplete: '/assets/audio/round_complete.wav',
  sessionComplete: '/assets/audio/session_complete.wav',
  workEnd: '/assets/audio/work_end.wav',
  workStart: '/assets/audio/work_start.wav',
};

class AudioService {
  constructor() {
    this.enabled = true;
    this.volume = 0.8;
    this._cache = {};
  }

  setEnabled(enabled) {
    this.enabled = enabled;
  }

  setVolume(volume) {
    this.volume = Math.min(1, Math.max(0, volume));
  }

  play(path) {
    if (!this.enabled) return;
    // Reuse a cloned node so quick consecutive plays don't cut each other.
    const audio = new Audio(path);
    audio.volume = this.volume;
    audio.play().catch(() => {
      // Ignorar errores porque los archivos
      // pueden no existir todavia.
    });
  }

  workStart() {
    this.play(AUDIO_PATHS.workStart);
  }

  workEnd() {
    this.play(AUDIO_PATHS.workEnd);
  }

  restStart() {
    this.play(AUDIO_PATHS.restStart);
  }

  countdownTick() {
    this.play(AUDIO_PATHS.countdownTick);
  }

  roundComplete() {
    this.play(AUDIO_PATHS.roundComplete);
  }

  sessionComplete() {
    this.play(AUDIO_PATHS.sessionComplete);
  }
}

export const audioService = new AudioService();
